import React from "react";
import { useNavigate, createSearchParams } from "react-router-dom";
import "../../css/home/ProductCards.css";

const ProductCards = () => {
    const navigate = useNavigate();
    const products = [
        {
            title: "AC Şarj İstasyonları",
            description: "AC şarj istasyonlarımız, elektrikli araçlarınızı güvenle ve hızlı bir şekilde şarj etmenizi sağlar.",
            image: "/assets/home/stations/dual.png",
            category: "AC İstasyonlar"
        },
        {
            title: "DC Şarj İstasyonları",
            description: "DC hızlı şarj istasyonları, kısa sürede maksimum enerji sağlar.",
            image: "/assets/home/stations/dc.png",
            category: "DC İstasyonlar"
        },
        {
            title: "Kablo Setleri",
            description: "Farklı uzunluk ve amper seçenekleriyle güvenli kablo çözümleri sunuyoruz.",
            image: "/assets/products/2kablolu.png",
            category: "Kablolar"
        },
        {
            title: "PCB Kartlar",
            description: "Yüksek performanslı PCB kartlarımız enerji yönetimi sağlar.",
            image: "/assets/products/pcb.png",
            category: "Elektronik Devreler"
        },
        {
            title: "Stantlar",
            description: "Stantlarımız, Cihazınızı şık ve güvenli bir şekilde muhafaza etmek için tasarlanmıştır.",
            image: "/assets/products/stant-sade.png",
            category: "Stantlar"
        },
        {
            title: "Adaptörler",
            description: "Farklı priz tipleri ve voltajlar için adaptörlerimizle enerjiyi yönlendirin.",
            image: "/assets/products/3lu.png",
            category: "Adaptörler"
        }
    ];
    
    const handleProductClick = (category) => {
        // DC İstasyonlar kategorisi için özel yönlendirme
        if (category === "DC İstasyonlar") {
            navigate("/dc");
        } else {
            navigate({
                pathname: "/products",
                search: createSearchParams({
                    category: category,
                }).toString(),
            });
        }
    };

    return (
        <div className="card-container">
            <div className="station-cards">
                {products.slice(0, 2).map((station, index) => (
                    <div
                        key={index}
                        className="station-card"
                        onClick={() => handleProductClick(station.category)}
                    >
                        <div className="card-content">
                            <h3 className="card-title">{station.title}</h3>
                            <p className="card-desc">{station.description}</p>
                        </div>
                        <div className="card-image">
                            <img src={station.image} alt={station.title} />
                        </div>
                    </div>
                ))}
            </div>

            <div className="product-grid">
                {products.slice(2).map((product, index) => (
                    <div
                        key={index}
                        className="product-card"
                        onClick={() => handleProductClick(product.category)}
                    >
                        <div className="card-content">
                            <h3 className="card-title">{product.title}</h3>
                            <p className="card-desc">{product.description}</p>
                        </div>
                        <div className="card-image">
                            <img src={product.image} alt={product.title} />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ProductCards;